import React from "react";
import { Link } from "react-router-dom";
import Sam from '../../assest/background/Sam.png';
function InvestRealState4() {
  document.title = "SimWealth";
  return (
    <>
      <div className="bg bg-InvestRealState1">
      <div data-aos="fade-left" className="container-fluid row  vh-100 w-100">
            <div className="col-sm-6 d-flex flex-column align-items-end justify-content-end my-auto text-center ">
                <div className="bg-white rounded-border p-4 border border-4 border-dark">
                  <p className="py-5 my-5">Sam purchased his rental property with a mortgage. Sam believes in using debt strategically. His belief is that the tenant is the one paying for the mortgage.</p>
                  <Link to={'/investing-in-real-estate/fifth-step'} className=" threeDButton btn fw-bold  w-50  ">Continue</Link>
                </div>
            </div>
            <div className="col-sm-6 d-flex  align-items-center justify-content-center position-relative ">
            <Link to={'/choose-a-simulation'} className=" threeDButton btn fw-bold RightBtn ">MainMenu</Link>
            <img src={Sam} className="SamImage" alt="Sam" /></div>
        </div>
      </div>
    </>
  );
}

export default InvestRealState4;
